import React, { Fragment, Suspense } from 'react'
import { Switch, Route, useLocation } from 'react-router-dom'
import Logout from 'Auth/Logout'
import Layout from './Layout'
import LazyFiller from 'shared/components/LazyFiller'
import AfterLogout from 'Auth/AfterLogout'
import Cleanup from 'Auth/Cleanup'
import PrivacyPage from 'Modules/PrivacyPage'
import CustomSwitch from 'shared/components/CustomSwitch'
import { shouldHideAppLayout } from 'shared/utils/hideLayout'
import PageLoader from 'shared/components/PageLoader'
import useWithOldPortalRedirect from 'shared/hooks/useWithOldPortalRedirect'

/** Lazy load modules */
const Economy = React.lazy(() => import('Modules/Economy'))
const HousingAssociation = React.lazy(
  () => import('Modules/HousingAssociation')
)
const Home = React.lazy(() => import('Modules/Home'))

const Boardwork = React.lazy(() => import('Modules/Boardwork'))
const HousingCooperative = React.lazy(
  () => import('Modules/HousingCooperative')
)

const Settings = React.lazy(() => import('Modules/Settings'))

const Communication = React.lazy(() => import('Modules/Communication'))
const Sustainability = React.lazy(() => import('Modules/Sustainability'))
const Auditor = React.lazy(() => import('Modules/Auditor'))
const Janitor = React.lazy(() => import('Modules/Janitor'))

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/privacy" exact component={PrivacyPage} />      
      <Route path="/" component={AppRoutes} />
    </Switch>
  )
}

const AppRoutes: React.FC = () => {
  const { pathname } = useLocation()
  const WrapperTag = shouldHideAppLayout(pathname) ? Fragment : Layout

  // Handle redirects from old portal
  useWithOldPortalRedirect()

  return (
    <WrapperTag>
      <Suspense fallback={<LazyFiller />}>
        <CustomSwitch>
          {/* Auth routes */}
          <Route path="/signin-oidc" component={PageLoader} />
          <Route path="/logout" component={Logout} />
          <Route path="/afterlogout" component={AfterLogout} />
          <Route path="/cleanup" component={Cleanup} />

          <Route path="/" exact component={Home} />

          <Route path="/okonomi" component={Economy} />
          <Route path="/boligselskapet" component={HousingAssociation} />
          <Route path="/styrearbeid" component={Boardwork} />
          <Route path="/kommunikasjon" component={Communication} />
          <Route path="/boligbyggelaget" component={HousingCooperative} />
          <Route path="/innstillinger" component={Settings} />
          <Route path="/barekraft" component={Sustainability} />
          <Route path="/revisor" component={Auditor} />
          <Route path="/vaktmester" component={Janitor} />
        </CustomSwitch>
      </Suspense>
    </WrapperTag>
  )
}

export default Routes
